import { readPath } from "./configForm";
import "./styles.css";

interface EffectiveValueProps {
    stored?: object;
    effective?: object;
    /** Dotted path into both layers. Leave it out to show only an error. */
    path?: string;
    error?: string;
    /** The path points at a secret's `isSet`: "set" or "not set", never a value. */
    secret?: boolean;
}

function describe(value: unknown, secret: boolean): string {
    if (secret) {
        return value === true ? "set" : "not set";
    }
    if (value === undefined || value === null) {
        return "not set";
    }
    if (value === true) {
        return "Yes";
    }
    if (value === false) {
        return "No";
    }
    return String(value);
}

/**
 * The line under a field: what this API host uses for it, and whether that
 * comes from appsettings because the database leaves it empty. It reflects the
 * last load or save, not unsaved edits. With no `effective` (the host has not
 * applied a database-only code) the page shows one note instead, so this shows
 * nothing.
 */
function EffectiveValue({ stored, effective, path, error, secret = false }: EffectiveValueProps) {
    const shown = effective !== undefined && path !== undefined;
    const value = shown ? readPath(effective, path) : undefined;
    const storedValue = shown ? readPath(stored, path) : undefined;
    const set = secret ? value === true : value !== undefined && value !== null;
    const storedSet = secret ? storedValue === true : storedValue !== undefined && storedValue !== null;
    const inherited = set && !storedSet;

    if (!shown && !error) {
        return null;
    }
    return (
        <div className="cc-note">
            {error && (
                <div
                    className="cc-error"
                    role="alert"
                >
                    {error}
                </div>
            )}
            {shown && (
                <div className="cc-effective">
                    In use: {describe(value, secret)}
                    {inherited && " · from appsettings"}
                </div>
            )}
        </div>
    );
}

export default EffectiveValue;
